import { render, staticRenderFns } from "./app-layout.vue?vue&type=template&id=4b5dcb73&scoped=true"
import script from "./app-layout.vue?vue&type=script&lang=js"
export * from "./app-layout.vue?vue&type=script&lang=js"
import style0 from "./app-layout.vue?vue&type=style&index=0&id=4b5dcb73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5dcb73",
  null
  
)

export default component.exports